<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <h3 class="page-title">OKR - Comercial</h3>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        
        <d-col class="mb-12 col-lg-12 lg-s">


          <d-card class="card-small go-stats">
            <!-- Card Header -->
            <d-card-header class="border-bottom">
              <h6 class="m-0" style="font-weight: 600">Melhorar a satisfação dos clientes</h6>
            </d-card-header>
            <d-card-body
              class="py-0"
            >
              <!-- Services List Group -->
              <d-list-group flush class="list-group-small list-group-flush">
                <d-list-group-item class="d-flex row px-0" >
                  <d-col lg="1" md="1" sm="1">
                    <center>
                      <img style="height: 50px;" src="https://image.flaticon.com/icons/svg/212/212240.svg" class="icon img-service" />
                    </center>
                  </d-col>
                  
                  <d-col lg="7" md="7" sm="7">
                    <h6 class="go-stats__label mb-1">Antingir índice de clientes captados através de venda <strong>OUTBOUND</strong>, em relação ao total de clientes no periodo, igual ou superior a met determinda.</h6>
                    <div class="go-stats__meta">
                      <span class="mr-2">
                        <strong>Meta no periodo: <strong class="text-success">99%</strong> de satisfação dos clientes.</strong>
                      </span>
                    </div>
                  </d-col>
                  <d-col lg="4" md="4" sm="4" class="d-flex">
                    <div class="go-stats__value text-right ml-auto">
                      <h6 class="go-stats__label mb-1">57.2%</h6>
                      <span class="go-stats__meta">Satisfação dos clientes</span>
                    </div>
                    <div class="go-stats__chart d-flex ml-auto"></div>
                  </d-col>
                </d-list-group-item>



                
                <d-list-group-item class="d-flex row px-0" >
                  <d-col lg="1" md="1" sm="1">
                    <center>
                      <img style="height: 50px;" src="https://image.flaticon.com/icons/svg/240/240072.svg" class="icon img-service" />
                    </center>
                  </d-col>
                  <d-col lg="7" md="7" sm="7">
                    <h6 class="go-stats__label mb-1">Antingir índice resposta de pesquisas igual ou superior a meta determinada.</h6>
                    <div class="go-stats__meta">
                      <span class="mr-2">
                        <strong>Meta no periodo: <strong class="text-success">30%</strong> de pesquisas respondidas.</strong>
                      </span>
                    </div>
                  </d-col>
                  <d-col lg="4" md="4" sm="4" class="d-flex">
                    <div class="go-stats__value text-right ml-auto">
                      <h6 class="go-stats__label mb-1">27.2%</h6>
                      <span class="go-stats__meta">Pesquisas respondidas</span>
                    </div>
                    <div class="go-stats__chart d-flex ml-auto"></div>
                  </d-col>
                </d-list-group-item>
              </d-list-group>
            </d-card-body>
            <d-card-footer class="border-top">
              <d-row>
                <!-- Footer -->
                <d-col class="text-right view-report">
                  
                </d-col>
              </d-row>
            </d-card-footer>
          </d-card>
        </d-col>


        
      </div>



      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <h3 class="page-title">OKR - Relacionamento</h3>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        
        <d-col class="mb-12 col-lg-12 lg-s">


          <d-card class="card-small go-stats">
            <!-- Card Header -->
            <d-card-header class="border-bottom">
              <h6 class="m-0" style="font-weight: 600">Melhorar a satisfação dos clientes, aumentar a retenção de clientes e otimização do tempo de go to market.</h6>
            </d-card-header>
            <d-card-body
              class="py-0"
            >
              <!-- Services List Group -->
              <d-list-group flush class="list-group-small list-group-flush">
                <d-list-group-item class="d-flex row px-0" >
                  <d-col lg="1" md="1" sm="1">
                    <center>
                      <img style="height: 50px;" src="https://image.flaticon.com/icons/svg/240/240411.svg" class="icon img-service" />
                    </center>
                  </d-col>
                  <d-col lg="7" md="7" sm="7">
                    <h6 class="go-stats__label mb-1">Antingir índice de satisfação igual ou superior da meta determinada.</h6>
                    <div class="go-stats__meta">
                      <span class="mr-2">
                        <strong>Meta no periodo: <strong class="text-success">99%</strong> de satisfação dos clientes.</strong>
                      </span>
                    </div>
                  </d-col>
                  <d-col lg="4" md="4" sm="4" class="d-flex">
                    <div class="go-stats__value text-right ml-auto">
                      <h6 class="go-stats__label mb-1">57.2%</h6>
                      <span class="go-stats__meta">Satisfação dos clientes</span>
                    </div>
                    <div class="go-stats__chart d-flex ml-auto"></div>
                  </d-col>
                </d-list-group-item>



                
                <d-list-group-item class="d-flex row px-0" >
                  <d-col lg="1" md="1" sm="1">
                    <center>
                      <img style="height: 50px;" src="https://image.flaticon.com/icons/svg/240/240072.svg" class="icon img-service" />
                    </center>
                  </d-col>
                  <d-col lg="7" md="7" sm="7">
                    <h6 class="go-stats__label mb-1">Antingir índice resposta de pesquisas igual ou superior a meta determinada.</h6>
                    <div class="go-stats__meta">
                      <span class="mr-2">
                        <strong>Meta no periodo: <strong class="text-success">30%</strong> de pesquisas respondidas.</strong>
                      </span>
                    </div>
                  </d-col>
                  <d-col lg="4" md="4" sm="4" class="d-flex">
                    <div class="go-stats__value text-right ml-auto">
                      <h6 class="go-stats__label mb-1">27.2%</h6>
                      <span class="go-stats__meta">Pesquisas respondidas</span>
                    </div>
                    <div class="go-stats__chart d-flex ml-auto"></div>
                  </d-col>
                </d-list-group-item>
              </d-list-group>
            </d-card-body>
            <d-card-footer class="border-top">
              <d-row>
                <!-- Footer -->
                <d-col class="text-right view-report">
                  
                </d-col>
              </d-row>
            </d-card-footer>
          </d-card>
        </d-col>


        
      </div>




    </div>
    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <date-field v-model="filter.EmissionDate" format="MMMM yyyy" minimumView="month"></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.Identifier" :value="null">
            <option :value="null" selected>Selecione a campanha</option>
            <option
              v-for="campaign in campaigns"
              v-bind:value="campaign.Identifier"
              v-bind:key="campaign.Identifier"
            >{{campaign.Description}}</option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "okrs",
  components: {
    dateField
  },
  data: function() {
    return {
      loadingList: false,
      countFilter: 1,
      labelName: "Cliente",
      labelIdentity: "CPF/CNPJ",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      filter: {
        Name: null,
        Identity: null,
        Identifier: null,
        EmissionDate: this.$options.filters.date(new Date(), "YYYY-MM-DD")
      },
      campaigns: [],
      merchantCampaigns: []
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListCampaignMerchant();
    },
    "pagination.RowsPerPage": function() {
      this.ListCampaignMerchant();
    }
  },
  mounted() {
    this.ListCampaignMerchant();
    this.ListCampaign();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListCampaignMerchant();
    },
    ListCampaignMerchant: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.Identifier)) this.countFilter++;
      if (hasValue(this.filter.EmissionDate)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Merchant.Name": this.filter.Name,
          "Object.Merchant.Identity": this.filter.Identity,
          "Object.Identifier": this.filter.Identifier,
          "Object.NoteExtract.EmissionDate": this.filter.EmissionDate
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListCampaignMerchant", { params: data })
        .then(response => {
          this.merchantCampaigns = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os clientes",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ListCampaign: function() {
      this.$store
        .dispatch("ListCampaign", {})
        .then(response => {
          this.campaigns = response.Objects;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as campanhas",
            error
          );
        });
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Identity: null,
        Identifier: null,
        EmissionDate: this.$options.filters.date(new Date(), "YYYY-MM-DD")
      };
      this.ListCampaignMerchant();
    }
  }
};
</script>

<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 10pt;
  opacity: 0.75;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/okrs.vue